import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

export default function Registries(props) {
    return (
        <Switch location={props.location}>
            <Route exact path={paths.registries} component={List} />
            <Route path={paths.registriesShow(":id")} component={Show} />
        </Switch>
    );
}
